import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses, bonusCoverSheet } from '../data/content';
import type { Bonus } from '../data/content';
const totalValue = bonuses.reduce((sum, bonus) => sum + bonus.value, 0);
export function Bonuses() {
  return <section id="boni" className="scroll-mt-4 bg-navy-800 px-5 py-16 sm:py-20" data-id="element-31" data-mp="asz4aht9qi41">
      <div className="mx-auto max-w-5xl" data-id="element-32" data-mp="fs3bx40jo7s9">
        <div className="mx-auto max-w-2xl text-center" data-id="element-33" data-mp="1u5cd4qvufwt">
          <p className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-gold/10 px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-gold" data-id="element-34" data-mp="1whoh19ylw1y">
            <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-35" data-mp="3o369yhbo54hb" />
            Gratis zu deiner Bestellung
          </p>
          <h2 className="mt-5 font-display text-3xl font-black leading-tight text-white sm:text-4xl" data-id="element-36" data-mp="3t2sp4wb24usr">
            Dazu erhältst du{' '}
            <span className="text-gold-light" data-id="element-37" data-mp="1r9uzf9ckuic1">5 Bonus-Materialien</span>{' '}
            geschenkt
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-38" data-mp="3ideke10bxu2r">
            Zusätzlich zu den sechs Praxisbänden bekommst du fünf digitale
            Bonus-PDFs für Planung, Organisation und Kommunikation – ohne
            Aufpreis.
          </p>
        </div>

        <ul className="mt-12 grid gap-4 md:grid-cols-2 md:gap-5" data-id="element-39" data-mp="3n4muz0deblhi">
          {bonuses.map((bonus, index) => <li key={bonus.number} className={index === bonuses.length - 1 ? 'md:col-span-2 md:mx-auto md:w-full md:max-w-[calc(50%-0.625rem)]' : ''} data-id="element-40" data-mp="2zeskgpgju90f" data-mpi={index}>
              <BonusCard bonus={bonus} data-id="element-41" data-mp="38dw53xvd6wh1" />
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-xl rounded-2xl border border-gold/40 bg-navy-900 px-6 py-5 text-center" data-id="element-42" data-mp="33ja1igviy87i">
          <p className="text-sm font-semibold text-white/70" data-id="element-43" data-mp="nruh2c8q1izd">
            Gesamtwert der Boni:{' '}
            <span className="text-white/50 line-through" data-id="element-44" data-mp="3ciwryrwu9nk7">{totalValue} €</span>
          </p>
          <p className="mt-1 font-display text-2xl font-black text-[#5ce08c]" data-id="element-45" data-mp="3cl95msvkdbrg">
            Für dich heute gratis
          </p>
        </div>
      </div>
    </section>;
}
function BonusCard({
  bonus
}: {
  bonus: Bonus;
}) {
  return <article className="flex h-full gap-4 rounded-2xl border border-white/10 bg-navy-700 p-4 sm:gap-5 sm:p-5" data-id="element-46" data-mp="3qj7ituy5f25d">
      <div role="img" aria-label={`Cover des Bonus-PDFs „${bonus.title}“`} className="aspect-[90/118] w-[88px] shrink-0 overflow-hidden rounded-lg shadow-lg shadow-black/40 sm:w-[104px]" style={{
      backgroundImage: `url("${bonusCoverSheet}")`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '598.9% auto',
      backgroundPosition: `5.79% ${bonus.coverY}%`
    }} data-id="element-47" data-mp="2tt82hebrazc8" />

      <div className="flex min-w-0 flex-1 flex-col" data-id="element-48" data-mp="2a2d2r4nbodui">
        <p className="font-display text-xs font-black uppercase tracking-[0.14em] text-gold" data-id="element-49" data-mp="2f2qz3pfk9zcp">
          Bonus {bonus.number}
        </p>
        <h3 className="mt-1.5 font-display text-base font-extrabold leading-snug text-white sm:text-lg" data-id="element-50" data-mp="27j89h0btb7v5">
          {bonus.title}
        </h3>
        <p className="mt-1 text-sm leading-snug text-white/65" data-id="element-51" data-mp="1xlk5rkw8aq0u">
          {bonus.subtitle}
        </p>
        <p className="mt-auto flex items-baseline gap-2 pt-3" data-id="element-52" data-mp="1tkrruecevwy8">
          <span className="font-display text-lg font-black uppercase text-[#5ce08c]" data-id="element-53" data-mp="1tmb9a89t0e1l">
            Gratis
          </span>
          <span className="text-sm text-white/45 line-through" data-id="element-54" data-mp="1jup2co4i114n">
            {bonus.value} €
          </span>
        </p>
      </div>
    </article>;
}